import React from "react";
import { Card, Badge } from "react-bootstrap";
import { TabPanel, TabView } from "primereact/tabview";
import { Editor } from "primereact/editor";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../../partials/content/Forms";
import { formatDate } from "../../../../../utils/utils";
const OutgoingPaymentBasicInfo = ({ payment }) => {
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="A/P Invoice Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Account Payable Payment Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="A/P Payment ID"
                            value={payment.outgoingPaymentCode}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Document Reference"
                                value={payment.docRefDesc}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              {payment.docRef === "1" ? (
                                <CustomOutlinedDisabledTextField
                                  label="A/P Invoice ID"
                                  value={payment.incomingInvoiceCode}
                                />
                              ) : (
                                <CustomOutlinedDisabledTextField
                                  label="Expense Account ID"
                                  value={payment.expenseAccountID}
                                />
                              )}
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Vendor Name"
                            value={payment.vendor.vendorName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Vendor Bank Account"
                            value={payment.vendBankAccountDesc}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Currency"
                                value={payment.currency.currencyCode}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Exchange Rate To Base Currency"
                                value={payment.exchangeRate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Cash Account"
                            value={payment.cashAccount.accountName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Payment Date"
                            value={formatDate(payment.paymentDate)}
                          />
                          {payment.docRef === "1" ? (
                            <CustomOutlinedDisabledCurrencyField
                              label="A/P Invoice Amount"
                              value={payment.incomingInvoice.grandTotal}
                            />
                          ) : null}
                          <CustomOutlinedDisabledCurrencyField
                            label="Payment Amount"
                            value={payment.paymentAmount}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Note" rightIcon="fas fa-sticky-note">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={payment.note}
                        placeholder="Type your notes here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OutgoingPaymentBasicInfo;
